import {computed, makeObservable, observable, action} from 'mobx';

export class SliderController {
  slides = []; // refs to all slides DOM elements
  #sliderContainerWidth: Number;
  @observable _totalSlidesWidth: Number;
  @observable currentPosition: Number = 0;
  @observable currentIndex: Number = 0;

  constructor() {
    makeObservable(this);
  }

  /**
   * Set slide element ref at a specific index
   */
  setSlideInIndex(index, slideElement) {
    this.slides[index] = slideElement;
  }

  get sliderContainerWidth(): Number {
    return this.#sliderContainerWidth;
  }

  set sliderContainerWidth(width) {
    this.#sliderContainerWidth = width;
  }

  get sliderContainerSlidesCount() {
    return Math.floor(this.sliderContainerWidth / this.getSlideWidth(0));
  }

  getSlideWidth(index) {
    return this.slides[index] ? this.slides[index].getBoundingClientRect().width : 0;
  }

  @computed get totalSlidesWidth() {
    return this._totalSlidesWidth;
  }

  set totalSlidesWidth(width) {
    this._totalSlidesWidth = width;
  }

  @computed get firstArrowActive() {
    return this.currentIndex > 0;
  }

  @computed get lastArrowActive() {
    return this.currentPosition < this.totalSlidesWidth - this.sliderContainerWidth;
  }

  @action update(index, position) {
    this.currentIndex = index;

    if (this.totalSlidesWidth - position <= this.sliderContainerWidth) {
      this.currentPosition = this.totalSlidesWidth - this.sliderContainerWidth < 0 ? 0 : this.totalSlidesWidth - this.sliderContainerWidth;
    } else if (position <= 0) {
      this.currentPosition = 0;
    } else {
      this.currentPosition = position;
    }

    return true;
  }

  get hasPrevSlide() {
    return this.currentIndex > 0;
  }

  @action handlePrevClick() {
    if (this.hasPrevSlide) {
      const newIndex = this.currentIndex - 1;
      const newPosition = this.currentPosition - this.getSlideWidth(newIndex);

      return this.update(newIndex, newPosition);
    } else {
      return false;
    }
  }

  get hasNextSlide() {
    return this.currentIndex < this.slides.length - this.sliderContainerSlidesCount && this.sliderContainerWidth < this.totalSlidesWidth;
  }

  @action handleNextClick() {
    if (this.hasNextSlide) {
      const newIndex = this.currentIndex + 1;
      const newPosition = this.currentPosition + this.getSlideWidth(newIndex);

      return this.update(newIndex, newPosition);
    } else {
      return false;
    }
  }

  reset() {
    this.currentPosition = 0;
    this.currentIndex = 0;
    this.slides = this.slides.filter(x => !!x);
  }
}
